import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Please enter email and password.");
      return;
    }

    setLoading(true);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      onLogin();
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <section className="login-hero">
        <div>
          <img src="/alm-logo.png" alt="ALM logo" className="brand-logo" />
          <p className="brand-subtitle">ALM Outsourcing Services Pvt Ltd.</p>
        </div>

        <div>
          <div className="eyebrow" style={{ color: "rgba(255,255,255,0.72)" }}>
            Corporate Invoice Engine
          </div>
          <h1>Secure billing, payroll files, and invoice PDFs in one workspace.</h1>
          <p>
            Sign in to generate client invoices, download consolidated PDF packs,
            and manage payroll outputs through a focused operations portal.
          </p>
        </div>

        <p className="brand-subtitle">
          (c) {new Date().getFullYear()} ALM Outsourcing Services Pvt Ltd.
        </p>
      </section>

      <section className="login-panel-wrap">
        <div className="login-panel">
          <div className="eyebrow">Secure Access</div>
          <h2 className="page-title" style={{ fontSize: 26 }}>Welcome back</h2>
          <p className="page-copy">Use your authorized account to continue.</p>

          <div className="field" style={{ marginTop: 24 }}>
            <label>Email Address</label>
            <input
              className="input"
              placeholder="name@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="field" style={{ marginTop: 16 }}>
            <label>Password</label>
            <input
              className="input"
              type="password"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button
            type="button"
            onClick={handleLogin}
            disabled={loading}
            className="btn btn-primary"
            style={{ width: "100%", marginTop: 22 }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </div>
      </section>
    </div>
  );
}
